import React from "react";
import SoftBox from "components/SoftBox";
import PageLayout from "examples/LayoutContainers/PageLayout";
import { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useCreateAccounts } from "queries/saas";
import { Link, useNavigate } from "react-router-dom";
import { useAgencyInfo } from "context/agency";
import Loader from "examples/Loader";
import Grid from "@mui/material/Grid";
import { Card, FormControlLabel, Icon, Slider, Switch, TextField, ToggleButton } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import CreateModal from "./components/CreateModal/index";
import SoftModal from 'components/SoftModal'
import "./style.css"
import EditsaasModal from "./components/EditsaasModal"
import ConfigrationForm from "./components/configration";
import EditModal from "../Teams/Users/components/EditModal";
import NormalTable from "./NormalTable";
const Pricing = ({ data, potentialproducts, handleRefresh }) => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false)
  // const [products, setproducts] = useState(data)
  const [prices, setPrices] = useState([])
  const queryClient = useQueryClient();
  const [agency] = useAgencyInfo();
  const [open, setOpen] = useState(false)
  const [editModalopen, setEditModalopen] = useState(false)
  const [editModaldata, setEditModaldata] = useState(false)

  const [openModal, setopenModal] = useState(false)
  const [editdata, seteditdata] = useState()
  const handleClose = () => {
    setOpen(false);
    setEditModalopen(false);
  }
  const openeditsaasmodel = (data) => {
    setopenModal(true);
    seteditdata(data);
  }
  const openModal_getId = (item) => {
    setEditModaldata(item)
    setEditModalopen(true);
  }
  const { mutateAsync: createAccounts } = useCreateAccounts();
  const handleCreateAccounts = async (product_id) => {
    const payload = {
      product_id: product_id
    }
    const { response } = await createAccounts(payload);
  }
  const stripe_currency = [
    {
      "label": "usd",
      "value": "$"
    },
    {
      "label": "eur",
      "value": "€"
    },
    {
      "label": "jpy",
      "value": "¥"
    },
    {
      "label": "gbp",
      "value": "£"
    },
    {
      "label": "aud",
      "value": "A$"
    },
    {
      "label": "cad",
      "value": "C$"
    },
    {
      "label": "chf",
      "value": "Fr"
    },
    {
      "label": "cny",
      "value": "¥"
    },
    {
      "label": "sek",
      "value": "kr"
    },
    {
      "label": "nzd",
      "value": "NZ$"
    },
    {
      "label": "krw",
      "value": "₩"
    },
    {
      "label": "sgd",
      "value": "S$"
    },
    {
      "label": "nok",
      "value": "kr"
    },
    {
      "label": "mxn",
      "value": "Mex$"
    },
    {
      "label": "inr",
      "value": "₹"
    },
    {
      "label": "rub",
      "value": "₽"
    },
    {
      "label": "zar",
      "value": "R"
    },
    {
      "label": "try",
      "value": "₺"
    },
    {
      "label": "brl",
      "value": "R$"
    },
    {
      "label": "twd",
      "value": "NT$"
    },
    {
      "label": "dkk",
      "value": "kr"
    },
    {
      "label": "pln",
      "value": "zł"
    },
    {
      "label": "thb",
      "value": "฿"
    },
    {
      "label": "idr",
      "value": "Rp"
    },
    {
      "label": "huf",
      "value": "Ft"
    },
    {
      "label": "czk",
      "value": "Kč"
    },
    {
      "label": "ils",
      "value": "₪"
    },
    {
      "label": "clp",
      "value": "CLP$"
    },
    {
      "label": "php",
      "value": "₱"
    },
    {
      "label": "aed",
      "value": "د.إ"
    },
    {
      "label": "cop",
      "value": "COL$"
    },
    {
      "label": "sar",
      "value": "﷼"
    },
    {
      "label": "myr",
      "value": "RM"
    },
    {
      "label": "ron",
      "value": "lei"
    },
    {
      "label": "pkr",
      "value": "₨"
    },
    {
      "label": "vnd",
      "value": "₫"
    },
    {
      "label": "ngn",
      "value": "₦"
    },
    {
      "label": "egp",
      "value": "E£"
    },
    {
      "label": "bdt",
      "value": "৳"
    },
    {
      "label": "pyg",
      "value": "₲"
    },
    {
      "label": "irr",
      "value": "﷼"
    },
    {
      "label": "iqd",
      "value": "ع.د"
    },
    {
      "label": "dzd",
      "value": "DA"
    },
    {
      "label": "kwd",
      "value": "ك"
    },
    {
      "label": "uah",
      "value": "₴"
    },
    {
      "label": "hrk",
      "value": "kn"
    },
    {
      "label": "omr",
      "value": "﷼"
    },
    {
      "label": "tnd",
      "value": "د.ت"
    },
    {
      "label": "qar",
      "value": "﷼"
    },
    {
      "label": "crc",
      "value": "₡"
    },
    {
      "label": "ars",
      "value": "AR$"
    },
    {
      "label": "lkr",
      "value": "₨"
    },
    {
      "label": "vnd",
      "value": "₫"
    },
    {
      "label": "mad",
      "value": "د.م."
    },
    {
      "label": "npr",
      "value": "रू"
    },
    {
      "label": "uzs",
      "value": "сўм"
    },
    {
      "label": "mvr",
      "value": "ރ."
    },
    {
      "label": "jod",
      "value": "د.ا"
    },
    {
      "label": "bhd",
      "value": "ب.د"
    },
    {
      "label": "kzt",
      "value": "₸"
    },
    {
      "label": "byn",
      "value": "Br"
    },
    {
      "label": "lbp",
      "value": "ل.ل."
    },
    {
      "label": "gtq",
      "value": "Q"
    },
    {
      "label": "ttd",
      "value": "TT$"
    },
    {
      "label": "svc",
      "value": "₡"
    },
    {
      "label": "afn",
      "value": "؋"
    },
    {
      "label": "yer",
      "value": "﷼"
    },
    {
      "label": "bob",
      "value": "Bs"
    },
    {
      "label": "bmd",
      "value": "BD$"
    },
    {
      "label": "bzd",
      "value": "BZ$"
    },
    {
      "label": "xcd",
      "value": "EC$"
    },
    {
      "label": "gel",
      "value": "₾"
    },
    {
      "label": "jmd",
      "value": "J$"
    },
    {
      "label": "kyd",
      "value": "KY$"
    },
    {
      "label": "mnt",
      "value": "₮"
    },
    {
      "label": "nad",
      "value": "N$"
    },
    {
      "label": "pab",
      "value": "B/."
    },
    {
      "label": "sdg",
      "value": "ج.س."
    },
    {
      "label": "sdp",
      "value": "£S"
    },
    {
      "label": "lvl",
      "value": "Ls"
    },
    {
      "label": "ltl",
      "value": "Lt"
    },
    {
      "label": "zwd",
      "value": "Z$"
    },
    {
      "label": "awg",
      "value": "Afl."
    },
    {
      "label": "bbd",
      "value": "Bds$"
    },
    {
      "label": "bgn",
      "value": "лв"
    },
    {
      "label": "cdf",
      "value": "FC"
    },
    {
      "label": "xof",
      "value": "CFA"
    },
    {
      "label": "djf",
      "value": "Fdj"
    },
    {
      "label": "fkp",
      "value": "FK£"
    },
    {
      "label": "gip",
      "value": "GIP"
    },
    {
      "label": "gnf",
      "value": "FG"
    },
    {
      "label": "htg",
      "value": "HTG"
    },
    {
      "label": "iqd",
      "value": "ع.د"
    },
    {
      "label": "irr",
      "value": "﷼"
    },
    {
      "label": "isk",
      "value": "kr"
    },
    {
      "label": "lak",
      "value": "₭"
    },
    {
      "label": "lsl",
      "value": "LSL"
    },
    {
      "label": "mmk",
      "value": "K"
    },
    {
      "label": "mro",
      "value": "UM"
    },
    {
      "label": "mzn",
      "value": "MT"
    },
    {
      "label": "nio",
      "value": "C$"
    },
    {
      "label": "pgk",
      "value": "PGK"
    },
    {
      "label": "rwf",
      "value": "R₣"
    },
    {
      "label": "shp",
      "value": "£"
    },
    {
      "label": "std",
      "value": "Db"
    },
    {
      "label": "szl",
      "value": "E"
    },
    {
      "label": "top",
      "value": "T$"
    },
    {
      "label": "ugx",
      "value": "USh"
    },
    {
      "label": "vuv",
      "value": "VT"
    },
    {
      "label": "wst",
      "value": "WS$"
    },
    {
      "label": "xaf",
      "value": "FCFA"
    },
    {
      "label": "xpf",
      "value": "F"
    },
    {
      "label": "zmw",
      "value": "ZK"
    }
  ]
  const handleRefereshpricing = () => {
    setEditModalopen(false)
    setEditModaldata(false)
    seteditdata(false)
    seteditdata(false)
    setOpen(false)

  }
  return (<>
    <Grid container>
      <Grid item xs={12}>

        <SoftBox >
          <NormalTable data={data} potentialproducts={potentialproducts} openeditsaasmodel={openeditsaasmodel} handleCreateAccounts={handleCreateAccounts} />
        </SoftBox >

      </Grid>
      {openModal &&
        <div className="modal-zz-confirm">

          <div className="scrollable-modal-content bg-white  rounded" style={{ position: "relative" }}>
            <h2 className='text-black text-left font-14'> Edit Saas : {editdata?.product_name}
            </h2>
            <span className='crossison' onClick={() => setopenModal(false)}>X</span>
            {/* Edit modal  */}
            <ConfigrationForm editdata={editdata} onClose={() => setopenModal(false)} handleRefereshpricing={handleRefereshpricing} handleRefresh={handleRefresh} />

          </div>
        </div>}

      {/* //CREATE MODAL  */}
      <CreateModal open={open} onClose={handleClose} prices={prices} handleRefresh={handleRefresh} />
      {/* <EditsaasModal open={editModalopen} onClose={handleClose} data={editModaldata} handleRefresh={handleRefresh} /> */}

    </Grid>
  </>)
}
export default Pricing